module.exports = __webpack_public_path__ + "img/20_47.62d80072.png";